// ! UTILITY ENUMS TO ASSIST WITH DB
// ! DO NOT CHANGE THESE ENUMS, UNLESS YOU KNOW WHAT THE IMPACT WILL BE
// ! DO NOT RENAME OR MOVE THIS FILE WITHOUT UPDATING ./github/workflows/deploy-stage.yml (the DB should be deployed if these enums change to upsert them correctly)
export var PlatformEnumId;
(function (PlatformEnumId) {
    PlatformEnumId[PlatformEnumId["shopify"] = 1] = "shopify";
    /** @deprecated BigCommerce no longer supported. */
    PlatformEnumId[PlatformEnumId["bigCommerce"] = 2] = "bigCommerce";
    PlatformEnumId[PlatformEnumId["custom"] = 3] = "custom";
})(PlatformEnumId || (PlatformEnumId = {}));
export var InvoiceSectionName;
(function (InvoiceSectionName) {
    InvoiceSectionName["protectedOrders"] = "Protected Orders";
    InvoiceSectionName["reorders"] = "Reorders";
    InvoiceSectionName["refunds"] = "Refunds";
    InvoiceSectionName["adjustments"] = "Adjustments";
    InvoiceSectionName["revShare"] = "Revenue Share";
    InvoiceSectionName["crewSubscriptionCharge"] = "Crew Subscription Charge";
})(InvoiceSectionName || (InvoiceSectionName = {}));
// ! POSTGRES ENUM (DO NOT CHANGE)
export const ShippingApiProvider = {
    easyPost: 'Easy_Post',
    vesyl: 'Vesyl',
    globalE: 'Global_E',
    happyReturns: 'Happy_Returns',
};
export var PlatformCode;
(function (PlatformCode) {
    PlatformCode["shopify"] = "Shopify";
    /** @deprecated BigCommerce no longer supported. */
    PlatformCode["bigCommerce"] = "BigCommerce";
    PlatformCode["custom"] = "Custom";
})(PlatformCode || (PlatformCode = {}));
export var BillingProviderEnum;
(function (BillingProviderEnum) {
    BillingProviderEnum["stripe"] = "Stripe";
    BillingProviderEnum["shopifySubscription"] = "Shopify_Subscription";
})(BillingProviderEnum || (BillingProviderEnum = {}));
// DEFAULT ENUMS USED TO SEED DATABASE ENUMS -- CHANGE WITH CAUTION
export var AddressTypeEnum;
(function (AddressTypeEnum) {
    AddressTypeEnum["billing"] = "Billing";
    AddressTypeEnum["fulfillment"] = "Fulfillment";
    AddressTypeEnum["shipping"] = "Shipping";
    AddressTypeEnum["return"] = "Return";
})(AddressTypeEnum || (AddressTypeEnum = {}));
export var AppTypeEnum;
(function (AppTypeEnum) {
    /** @deprecated */
    AppTypeEnum["gsp"] = "GSP";
    AppTypeEnum["crew"] = "CREW";
})(AppTypeEnum || (AppTypeEnum = {}));
export var InvoiceStatusEnum;
(function (InvoiceStatusEnum) {
    InvoiceStatusEnum["generated"] = "Generated";
    InvoiceStatusEnum["submitted"] = "Submitted";
    InvoiceStatusEnum["paid"] = "Paid";
    InvoiceStatusEnum["partiallyPaid"] = "Partially_Paid";
    InvoiceStatusEnum["uncollectable"] = "Uncollectable";
    InvoiceStatusEnum["zeroDollar"] = "Zero_Dollar";
    InvoiceStatusEnum["writtenOff"] = "Written_Off";
    InvoiceStatusEnum["submissionScheduled"] = "Submission_Scheduled";
})(InvoiceStatusEnum || (InvoiceStatusEnum = {}));
export var CommissionPayeeTypeEnum;
(function (CommissionPayeeTypeEnum) {
    CommissionPayeeTypeEnum["partner"] = "Partner";
    CommissionPayeeTypeEnum["accountExecutive"] = "Account_Executive";
    CommissionPayeeTypeEnum["merchant"] = "Merchant";
})(CommissionPayeeTypeEnum || (CommissionPayeeTypeEnum = {}));
export var ContactTypeEnum;
(function (ContactTypeEnum) {
    ContactTypeEnum["billing"] = "Billing";
    ContactTypeEnum["support"] = "Support";
})(ContactTypeEnum || (ContactTypeEnum = {}));
export var InvoiceAdjustmentTypeEnum;
(function (InvoiceAdjustmentTypeEnum) {
    InvoiceAdjustmentTypeEnum["invoiceCreditCreate"] = "Invoice_Credit_Create";
    InvoiceAdjustmentTypeEnum["credit"] = "Credit";
    InvoiceAdjustmentTypeEnum["debit"] = "Debit";
    InvoiceAdjustmentTypeEnum["invoiceCreditApply"] = "Invoice_Credit_Apply";
})(InvoiceAdjustmentTypeEnum || (InvoiceAdjustmentTypeEnum = {}));
export var RefundMethodEnum;
(function (RefundMethodEnum) {
    RefundMethodEnum["paypal"] = "Paypal";
    RefundMethodEnum["venmo"] = "Venmo";
    RefundMethodEnum["shopifyAdmin"] = "Shopify_Admin";
    RefundMethodEnum["shopifyApi"] = "Shopify_API";
})(RefundMethodEnum || (RefundMethodEnum = {}));
//* these aren't true enums, but they are used like enums *//
//* used to populate a unique name on relationship tables claim_status, claim_status_detail, claim_category *//
//* allows us to reference a unique name instead of an id *//
export const PermissionsCode = {
    readOrders: 'read:orders',
    writeOrders: 'write:orders',
    readStores: 'read:stores',
    readClaims: 'read:claims',
    readShippingClaims: 'read:shipping-claims',
    writeShippingClaims: 'write:shipping-claims',
    readRegistrations: 'read:registrations',
    readProducts: 'read:products',
    writeProducts: 'write:products',
};
export const seedPermissionsObject = [
    {
        where: { code: PermissionsCode.readOrders },
        create: {
            code: PermissionsCode.readOrders,
            name: 'Read Orders',
            description: 'Read orders permission',
        },
        update: { name: 'Read Orders', description: 'Read orders permission' },
    },
    {
        where: { code: PermissionsCode.writeOrders },
        create: {
            code: PermissionsCode.writeOrders,
            name: 'Write Orders',
            description: 'Write orders permission',
        },
        update: { name: 'Write Orders', description: 'Write orders permission' },
    },
    {
        where: { code: PermissionsCode.readStores },
        create: {
            code: PermissionsCode.readStores,
            name: 'Read stores',
            description: 'Read stores permission',
        },
        update: { name: 'Read stores', description: 'Read stores permission' },
    },
    {
        where: { code: PermissionsCode.readClaims },
        create: {
            code: PermissionsCode.readClaims,
            name: 'Read Claims',
            description: 'Read claims permission',
        },
        update: { name: 'Read Claims', description: 'Read claims permission' },
    },
    {
        where: { code: PermissionsCode.readShippingClaims },
        create: {
            code: PermissionsCode.readShippingClaims,
            name: 'Read Shipping Claims',
            description: 'Read shipping claims permission',
        },
        update: {
            name: 'Read Shipping Claims',
            description: 'Read shipping claims permission',
        },
    },
    {
        where: { code: PermissionsCode.writeShippingClaims },
        create: {
            code: PermissionsCode.writeShippingClaims,
            name: 'Write Shipping Claims',
            description: 'Write shipping claims permission',
        },
        update: {
            name: 'Write Shipping Claims',
            description: 'Write shipping claims permission',
        },
    },
    {
        where: { code: PermissionsCode.readRegistrations },
        create: {
            code: PermissionsCode.readRegistrations,
            name: 'Read Registrations',
            description: 'Read registrations permission',
        },
        update: {
            name: 'Read Registrations',
            description: 'Read registrations permission',
        },
    },
    {
        where: { code: PermissionsCode.readProducts },
        create: {
            code: PermissionsCode.readProducts,
            name: 'Read Products',
            description: 'Read products permission',
        },
        update: {
            name: 'Read Products',
            description: 'Read products permission',
        },
    },
    {
        where: { code: PermissionsCode.writeProducts },
        create: {
            code: PermissionsCode.writeProducts,
            name: 'Write Products',
            description: 'Write products permission',
        },
        update: {
            name: 'Write Products',
            description: 'Write products permission',
        },
    },
];
export const RoleCode = {
    corsoAdmin: 'Corso_Admin',
    admin: 'Admin',
    staff: 'Staff',
    commerceApiAdmin: 'Commerce_API_Admin',
};
export const roleCodeName = {
    [RoleCode.corsoAdmin]: 'Corso Admin',
    [RoleCode.admin]: 'Admin',
    [RoleCode.staff]: 'Staff',
    [RoleCode.commerceApiAdmin]: 'Commerce API Admin',
};
// only return the highest role available to the user
export function getHighestRole(roles) {
    if (roles.includes(RoleCode.admin)) {
        return RoleCode.admin;
    }
    if (roles.includes(RoleCode.corsoAdmin)) {
        return RoleCode.corsoAdmin;
    }
    if (roles.includes(RoleCode.staff)) {
        return RoleCode.staff;
    }
    throw new Error('User has no role');
}
export const seedRolesObject = [
    {
        where: { code: RoleCode.commerceApiAdmin },
        create: {
            code: RoleCode.commerceApiAdmin,
            name: 'Commerce API Admin',
            description: 'Admin User for programmatic access of Commerce API',
        },
        update: {
            name: 'Commerce API Admin',
            description: 'Admin User for programmatic access of Commerce API',
        },
    },
    {
        where: { code: RoleCode.admin },
        create: { code: RoleCode.admin, name: 'Admin', description: 'Admin User' },
        update: { name: 'Admin', description: 'Admin User' },
    },
    {
        where: { code: RoleCode.corsoAdmin },
        create: {
            code: RoleCode.corsoAdmin,
            name: 'Corso Admin',
            description: 'Corso Admin User for managing an installed CREW store',
        },
        update: {
            name: 'Corso Admin',
            description: 'Corso Admin User for managing an installed CREW store',
        },
    },
    {
        where: { code: RoleCode.staff },
        create: { code: RoleCode.staff, name: 'Staff', description: 'Staff User' },
        update: { name: 'Staff', description: 'Staff User' },
    },
];
export var BulkOperationType;
(function (BulkOperationType) {
    BulkOperationType["product"] = "Product";
    BulkOperationType["order"] = "Order";
    BulkOperationType["variant"] = "Variant";
    BulkOperationType["variantMetafield"] = "Variant_Metafield";
})(BulkOperationType || (BulkOperationType = {}));
//# sourceMappingURL=enum.js.map